"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLatLngToGeoPoint = exports.convertGeoPointToLatLng = void 0;
function convertGeoPointToLatLng(geoJsonDto) {
    if (geoJsonDto.type !== "Point")
        throw new Error("Only points can be converted to lat/lng objects, got this instead: " + JSON.stringify(geoJsonDto));
    return { lng: geoJsonDto.coordinates[0], lat: geoJsonDto.coordinates[1] };
}
exports.convertGeoPointToLatLng = convertGeoPointToLatLng;
function convertLatLngToGeoPoint(latLng) {
    return { type: "Point", coordinates: [latLng.lng, latLng.lat] };
}
exports.convertLatLngToGeoPoint = convertLatLngToGeoPoint;
